"use client";

import { useReportBoundaryCrash } from "~/hooks/useReportBoundaryCrash";

export default function Error({
    error,
    reset,
}: {
    error: Error & { digest?: string };
    reset: () => void;
}) {
    useReportBoundaryCrash(error);

    const handleRefresh = () => window.location.reload();

    return (
        <div className="flex flex-col items-center justify-center min-h-[50vh] p-5 text-center">
            <h2 className="text-2xl mb-4">Something went wrong</h2>
            <p className="text-gray-500 mb-6 max-w-[400px]">
                A loading error occurred. This usually resolves with a page refresh.
            </p>
            <div className="flex gap-3">
                <button
                    onClick={reset}
                    className="px-6 py-3 text-base bg-white text-black border border-gray-300 rounded-lg cursor-pointer"
                >
                    Try Again
                </button>
                <button
                    onClick={handleRefresh}
                    className="px-6 py-3 text-base bg-black text-white border-none rounded-lg cursor-pointer"
                >
                    Refresh Page
                </button>
            </div>
        </div>
    );
}
